/* RESPONSIBLE TEAM: team-ai-insights */

import type { CxBenchmarkData } from 'embercom/components/reporting/bespoke/fin-performance/cx-benchmark-panel/types';

// Hardcoded benchmark data for frontend development.
// This will be replaced by a real API call to GET /api/teammate_app/cx_benchmarks.
export const MOCK_CX_BENCHMARK_DATA: CxBenchmarkData = {
  app_industry: 'software_and_technology',
  app_segment: '1k_to_15k',

  benchmarks: {
    'overall:overall': {
      percentiles: {
        p5: 0.31,
        p10: 0.42,
        p15: 0.48,
        p20: 0.52,
        p25: 0.55,
        p30: 0.58,
        p35: 0.6,
        p40: 0.62,
        p45: 0.64,
        p50: 0.66,
        p55: 0.68,
        p60: 0.7,
        p65: 0.72,
        p70: 0.74,
        p75: 0.77,
        p80: 0.8,
        p85: 0.83,
        p90: 0.87,
        p95: 0.92,
        p100: 0.97,
      },
      reasons: {
        answer_quality_bot_high: 0.206,
        answer_quality_bot_low: 0.118,
        product_feedback_positive: 0.089,
        product_feedback_negative: 0.21,
        policy_feedback_positive: 0.052,
        policy_feedback_negative: 0.074,
        user_strong_emotion_positive: 0.031,
        user_strong_emotion_negative: 0.045,
        user_effort_low: 0.142,
        user_effort_high: 0.098,
        informational_query: 0.333,
        personalized_query: 0.116,
      },
    },

    'overall:1k_to_15k': {
      percentiles: {
        p5: 0.33,
        p10: 0.44,
        p15: 0.49,
        p20: 0.53,
        p25: 0.56,
        p30: 0.59,
        p35: 0.61,
        p40: 0.63,
        p45: 0.65,
        p50: 0.67,
        p55: 0.69,
        p60: 0.71,
        p65: 0.73,
        p70: 0.75,
        p75: 0.78,
        p80: 0.81,
        p85: 0.84,
        p90: 0.88,
        p95: 0.93,
        p100: 0.98,
      },
      reasons: {
        answer_quality_bot_high: 0.215,
        answer_quality_bot_low: 0.112,
        product_feedback_positive: 0.092,
        product_feedback_negative: 0.198,
        policy_feedback_positive: 0.055,
        policy_feedback_negative: 0.07,
        user_strong_emotion_positive: 0.033,
        user_strong_emotion_negative: 0.042,
        user_effort_low: 0.148,
        user_effort_high: 0.092,
        informational_query: 0.341,
        personalized_query: 0.112,
      },
    },

    'software_and_technology:overall': {
      percentiles: {
        p5: 0.35,
        p10: 0.45,
        p15: 0.5,
        p20: 0.54,
        p25: 0.57,
        p30: 0.6,
        p35: 0.62,
        p40: 0.64,
        p45: 0.66,
        p50: 0.68,
        p55: 0.7,
        p60: 0.72,
        p65: 0.74,
        p70: 0.76,
        p75: 0.79,
        p80: 0.82,
        p85: 0.85,
        p90: 0.89,
        p95: 0.93,
        p100: 0.97,
      },
      reasons: {
        answer_quality_bot_high: 0.224,
        answer_quality_bot_low: 0.105,
        product_feedback_positive: 0.095,
        product_feedback_negative: 0.19,
        policy_feedback_positive: 0.058,
        policy_feedback_negative: 0.068,
        user_strong_emotion_positive: 0.035,
        user_strong_emotion_negative: 0.04,
        user_effort_low: 0.155,
        user_effort_high: 0.088,
        informational_query: 0.352,
        personalized_query: 0.108,
      },
    },

    'software_and_technology:1k_to_15k': {
      percentiles: {
        p5: 0.36,
        p10: 0.46,
        p15: 0.51,
        p20: 0.55,
        p25: 0.58,
        p30: 0.61,
        p35: 0.63,
        p40: 0.65,
        p45: 0.67,
        p50: 0.69,
        p55: 0.71,
        p60: 0.73,
        p65: 0.75,
        p70: 0.77,
        p75: 0.8,
        p80: 0.83,
        p85: 0.86,
        p90: 0.9,
        p95: 0.94,
        p100: 0.98,
      },
      reasons: {
        answer_quality_bot_high: 0.231,
        answer_quality_bot_low: 0.101,
        product_feedback_positive: 0.098,
        product_feedback_negative: 0.185,
        policy_feedback_positive: 0.06,
        policy_feedback_negative: 0.065,
        user_strong_emotion_positive: 0.037,
        user_strong_emotion_negative: 0.038,
        user_effort_low: 0.16,
        user_effort_high: 0.085,
        informational_query: 0.36,
        personalized_query: 0.105,
      },
    },

    'fintech:overall': {
      percentiles: {
        p5: 0.28,
        p10: 0.38,
        p15: 0.44,
        p20: 0.48,
        p25: 0.52,
        p30: 0.55,
        p35: 0.58,
        p40: 0.6,
        p45: 0.62,
        p50: 0.64,
        p55: 0.66,
        p60: 0.68,
        p65: 0.7,
        p70: 0.73,
        p75: 0.76,
        p80: 0.79,
        p85: 0.83,
        p90: 0.87,
        p95: 0.92,
        p100: 0.96,
      },
      reasons: {
        answer_quality_bot_high: 0.195,
        answer_quality_bot_low: 0.13,
        product_feedback_positive: 0.082,
        product_feedback_negative: 0.225,
        policy_feedback_positive: 0.048,
        policy_feedback_negative: 0.082,
        user_strong_emotion_positive: 0.028,
        user_strong_emotion_negative: 0.052,
        user_effort_low: 0.135,
        user_effort_high: 0.108,
        informational_query: 0.31,
        personalized_query: 0.125,
      },
    },
  },
};
